import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();

export default class EmployeeAPI {

    URI_V1 = "/v1/employees"

    getProfits = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        var query = `startDate=${filter.startDate}&endDate=${filter.endDate}&companyId=${companyAPI.getCompanyManagment().id}`;
        return await apiService.get(`${this.URI_V1}/${filter.employeeId}/profits?${query}`);
    };


    getSummary = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        var query = `startDate=${filter.startDate}&endDate=${filter.endDate}&companyId=${companyAPI.getCompanyManagment().id}`;
        return await apiService.get(`${this.URI_V1}/summary?${query}`);
    };
    

    pay = async (employeeId: any, data: any) => {
        return await apiService.post(`${this.URI_V1}/${employeeId}/pay`, data);
    };

    payPending = async (employeeId: any, data: any) => {
        return await apiService.post(`${this.URI_V1}/${employeeId}/pay-pending`, data);
    };

    getSummaryPay = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        var query = `startDate=${filter.startDate}&endDate=${filter.endDate}&companyId=${companyAPI.getCompanyManagment().id}`;
        return await apiService.get(`${this.URI_V1}/summary/pay?${query}`);
    };

    getSummaryPendingPay = async () => {
        const companyAPI = new CompanyAPI();
        var query = `companyId=${companyAPI.getCompanyManagment().id}`;
        return await apiService.get(`${this.URI_V1}/summary/pending-pay?${query}`);
    };

    getSummaryPendingPayDetail = async (employeeId: any) => {
        const companyAPI = new CompanyAPI();
        var query = `companyId=${companyAPI.getCompanyManagment().id}`;
        return await apiService.get(`${this.URI_V1}/${employeeId}/pending-pay-detail?${query}`);
    };

    commissionDetails = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        var query = `startDate=${filter.startDate}&endDate=${filter.endDate}&companyId=${companyAPI.getCompanyManagment().id}`;
        return await apiService.get(`${this.URI_V1}/${filter.employeeId}/commission/details?${query}`);
    };

    getCommissions = async (employeeId: any) => {
        const companyAPI = new CompanyAPI();
        var query = `employeeId=${employeeId}&companyId=${companyAPI.getCompanyManagment().id}`;
        return await apiService.get(`${this.URI_V1}/commissions?${query}`);
    };

    rollbackCommissionPayment = async ( data: any) => {
        const companyAPI = new CompanyAPI();
        return apiService.delete(`${this.URI_V1}/${data.employeeId}/commission/rollback?paymentDate=${data.paymentDate}&companyId=${companyAPI.getCompanyManagment().id}`, data);
    };

}
